import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckoutForm from './CheckoutForm';
import { fundRaiserPageAction } from '../../store/actions';

export function DonateCampaign() {
    let dispatch = useDispatch();
    let pageId = window.location.pathname.split("/");
    pageId = pageId[pageId.length - 1]
    const pageDetails = useSelector(state => state.fundraiser_page.campaign_details)

    useEffect(() => {
        dispatch(fundRaiserPageAction.getCampaignDetails(pageId));
    }, [])
    return <CheckoutForm isFundraiserCheckout={false} pageDetails={pageDetails} />
}
